import { Component, OnInit } from "@angular/core";
import { UsersService } from "@service/users.service";
import { environment } from "@env/environment";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-invite-link",
  templateUrl: "./invite-link.component.html",
  styleUrls: ["./invite-link.component.scss"],
})
export class InviteLinkComponent implements OnInit {
  // ! criar uma rota só pra pegar o codigo de convite primeiramente
  showInvite: boolean = false;
  loading: boolean = false;
  public invitationUrl: string;
  public invitationCode: string;
  isClicked: boolean = false;
  copied: boolean = false;
  showCheckmark: boolean = false;

  constructor(
    private usersService: UsersService,
    private toast: ToastrService
  ) {}

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    this.usersService.getInvitationCode(user.id).subscribe((res) => {
      this.invitationUrl = `${environment.base_server}/?indique=${res.code}`;
      this.invitationCode = res.code;
      this.loading = true;
    });
  }

  handleClick() {
    this.isClicked = !this.isClicked;
  }

  handleInvite(invite: boolean) {
    this.showInvite = invite;
  }

  private fallbackCopyTextToClipboard(text: string) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text command was " + msg);
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  }

  stringToClipboard(text: string) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }
  
    navigator.clipboard.writeText(text).then(
      () => {
        console.log("Async: Copying to clipboard was successful!");
        this.showCheckmark = true;
        setTimeout(() => {
          this.showCheckmark = false;
        }, 2000); // Tempo em milissegundos para manter o ícone de confirmação (2 segundos neste exemplo)
        this.toast.success("Link Copiado!");
      },
      (err) => {
        console.error("Async: Could not copy text: ", err);
      }
    );
  }
  
}
